import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, onValue, set, onDisconnect, serverTimestamp as rtdbTimestamp } from "firebase/database";

export function initQuickPresence() {
  const auth = getAuth();
  const rtdb = getDatabase();

  onAuthStateChanged(auth, (user) => {
    if (!user) return;

    const userStatusRef = ref(rtdb, `status/${user.uid}`);

    // Define states
    const isOfflineData = { isOnline: false, lastSeen: rtdbTimestamp() };
    const isOnlineData = { isOnline: true, lastSeen: rtdbTimestamp() };

    // Connection listener
    onValue(ref(rtdb, ".info/connected"), (snapshot) => {
      if (snapshot.val() === false) return;

      // STEP 1: Set up the server-side "On Disconnect" instruction
      onDisconnect(userStatusRef)
        .set(isOfflineData)
        .then(() => {
          // STEP 2: Once the instruction is saved, mark user as Online
          set(userStatusRef, isOnlineData);
        })
        .catch((err) => console.error("Presence setup failed:", err));
    });
  });
}


// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import {
//   getFirestore,
//   collection,
//   query,
//   where,
//   limit,
//   getDocs,
//   updateDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import {
//   getDatabase,
//   ref,
//   onValue,
//   set,
//   onDisconnect,
// } from "firebase/database";

// /**
//  * Tracks real-time presence for authenticated users.
//  * Keeps Firestore and Realtime Database in sync with user online/offline status.
//  */
// export function initQuickPresence() {
//   const auth = getAuth();
//   const db = getFirestore();
//   const rtdb = getDatabase();



//   onAuthStateChanged(auth, async (user) => {
//     if (!user) {

//       return;
//     }



//     try {
//       // --- Step 1: Find the user’s Firestore document ---
//       const q = query(
//         collection(db, "users"),
//         where("authUID", "==", user.uid),
//         limit(1)
//       );
//       const snap = await getDocs(q);

//       if (snap.empty) {
//         console.warn(`⚠️ No Firestore document found for UID: ${user.uid}`);
//         return;
//       }

//       const userDocRef = snap.docs[0].ref;
//       const userDocPath = userDocRef.path;


//       // --- Step 2: Setup the RTDB path for user’s presence ---
//       const userStatusRef = ref(rtdb, `status/${user.uid}`);


//       // --- Step 3: Define online/offline states ---
//       const offlineStatus = { isOnline: false, lastSeen: serverTimestamp() };
//       const onlineStatus = { isOnline: true, lastSeen: serverTimestamp() };

//       // --- Step 4: Listen for RTDB connection changes ---

//       onValue(ref(rtdb, ".info/connected"), async (snapshot) => {
//         const connected = snapshot.val();


//         if (!connected) {
  
//           await updateDoc(userDocRef, offlineStatus);
      
//           return;
//         }

//         try {
//           // Register disconnect behavior

//           await onDisconnect(userStatusRef).set(offlineStatus);
    

//           // Immediately mark online in RTDB and Firestore
//           await set(userStatusRef, onlineStatus);


//           await updateDoc(userDocRef, onlineStatus);
 
//         } catch (err) {
//           console.error("❌ Error while updating user status:", err);
//         }
//       });
//     } catch (error) {
//       console.error("🔥 Error initializing presence tracking:", error);
//     }
//   });
// }
